import { getReferralCodeGetAmount } from 'common/ReferTextUtilities';
import { CurrentUserFieldsFragment } from 'src/gqlReactTypings.generated.d';
import { canSeeApplication, canSeeDashboard } from 'src/shared/utils/ShefStatusUtilities';
import { match } from 'ts-pattern';

type ShefLinkType = 'become-a-shef' | 'shef-application' | 'shef-dashboard' | 'waitlist-home';

export const getShefLinkType = (currentUser: CurrentUserFieldsFragment | null): ShefLinkType => {
  const shefStatus = currentUser?.shefStatus;
  const isWaitlistedShef = !!currentUser?.shefApplication?.isWaitlisted;

  const canSeeShefDashboardLink = (shefStatus && canSeeDashboard(shefStatus)) ?? false;
  const canSeeShefApplicationLink = (shefStatus && canSeeApplication(shefStatus)) ?? false;

  return match<
    { canSeeShefDashboardLink: boolean; canSeeShefApplicationLink: boolean; isWaitlistedShef: boolean },
    ShefLinkType
  >({
    canSeeShefDashboardLink,
    canSeeShefApplicationLink,
    isWaitlistedShef,
  })
    .with({ isWaitlistedShef: true }, () => 'waitlist-home')
    .with({ canSeeShefDashboardLink: true }, () => 'shef-dashboard')
    .with({ canSeeShefApplicationLink: true }, () => 'shef-application')
    .otherwise(() => 'become-a-shef');
};

const DEFAULT_REFERRAL_SHARE_TEXT = 'Get $10';

export const getReferralShareText = (currentUser: CurrentUserFieldsFragment | null) =>
  currentUser ? getReferralCodeGetAmount({ referralCode: currentUser.referralCode }) : DEFAULT_REFERRAL_SHARE_TEXT;
